import type { DFunction } from "lib/dict";
import type { ResourceType } from "components/role/RoleForm";
import type { PermissionDenial, RequiredPermission } from "./permissionDenied";

// 要る権限を、ロール編集画面と同じ名前で書く（管理者がどこを直せばよいか分かるように）。
// 操作はロール編集画面の列見出しと同じ read / write / export。見積申請などの個別の操作はその名前にする
const permissionLabel = (permission: RequiredPermission, resources: ResourceType[], d: DFunction): string => {
  const resource = resources.find((r) => r.key === permission.resource);
  if (!resource) return `${permission.resource}（${permission.action}）`;
  const translated = resource.nameKey ? d(resource.nameKey) : resource.name;
  // nameKey の namespace をその画面が読み込んでいないと、d はキーをそのまま返す
  const name = translated && translated !== resource.nameKey ? translated : permission.resource;
  const other = resource.others.find((o) => o.value === permission.action);
  return `${name}（${other ? other.label : permission.action}）`;
};

export const permissionDeniedMessage = (denial: PermissionDenial, resources: ResourceType[], d: DFunction): string => {
  if (denial.requiresRoot) return d("common:permission_denied_notice.root_only");
  if (denial.requiredPermissions.length === 0) return d("common:permission_denied_notice.unknown");
  const permissions = denial.requiredPermissions.map((p) => permissionLabel(p, resources, d)).join("、");
  return denial.requiredPermissions.length === 1
    ? d("common:permission_denied_notice.single", { permissions })
    : d("common:permission_denied_notice.any_of", { permissions });
};
